import { useEffect, useState } from "react";
import { usePixiMouseEventListener } from "./usePixiMouseEventListener.js";
/**
 * provides a focused value which becomes true onMouseEnter and false onMouseLeave
 * @param ref ref to a DOM element
 * @param disabled
 */
export const useFocused = (ref, disabled = false) => {
    const [focused, setFocused] = useState(false);
    usePixiMouseEventListener(() => setFocused(!disabled && true), ref, false, "mouseenter");
    usePixiMouseEventListener(() => setFocused(false), ref, false, "mouseleave");
    useEffect(() => {
        if (disabled) {
            setFocused(false);
        }
    }, [disabled]);
    return focused;
};
//# sourceMappingURL=useFocused.js.map